//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { InvoiceStatus } from './Enums';

export class InvoiceDetailsDisplayItem extends ItemBase {
    ID: string = "00000000-0000-0000-0000-000000000000";
    InvoiceID: string | null = null;
    IsPayable: boolean = false;
    AmountDue: number | null = null;
    FamilyID: string | null = null;
    FamilyName: string | null = null;
    ParentIDs: string[] = [];
    InvoiceStatus: InvoiceStatus = InvoiceStatus.Void;
    LateFee: number | null = null;

    constructor(initializer?: Partial<InvoiceDetailsDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "InvoiceDetailsDisplayItem";
}
